/**
 * G3. Буллинг: три реплики и три ответа, у каждого ответа честно написан
 * шанс остановить травлю (по отношениям и стране). Блок помощи рисует
 * каркас (`heavy`). В режиме «пропускать тяжёлое» — только текст и
 * «Дальше»: логика сама даёт ожидаемый исход.
 */
import { t } from '@life/i18n';
import { bullyingAnswerP, type BullyingAnswer, type BullyingInput, type BullyingState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Bullying({ state, onInput, skipHeavy }: MinigameScreenProps<BullyingInput, BullyingState>) {
  const [picks, setPicks] = useState<(number | null)[]>(() => state.lines.map(() => null));
  const complete = picks.every((p) => p !== null);

  if (skipHeavy || state.hidden) {
    return (
      <>
        <p class="hint">{t('ui.minigame.bullying.hidden')}</p>
        <button type="button" class="btn block" onClick={() => onInput({ picks: [] })}>
          {t('ui.minigame.continue')}
        </button>
      </>
    );
  }

  return (
    <>
      {state.support && <p class="hint">{t('ui.minigame.bullying.support')}</p>}
      {state.lines.map((key, i) => (
        <div class="q" key={key} data-question={i}>
          <p class="q-text">{t(key)}</p>
          <Choice
            label={t(key)}
            items={state.answers.map((a: BullyingAnswer) => ({
              text: t(`${key}.${a}`),
              note: t('ui.minigame.chance', { p: Math.round(bullyingAnswerP(state, a) * 100) }),
            }))}
            value={picks[i] ?? null}
            onChange={(j) => setPicks(picks.map((p, k) => (k === i ? j : p)))}
          />
        </div>
      ))}
      <button type="button" class="btn accent block" disabled={!complete} onClick={() => onInput({ picks: picks.map((p) => p ?? 0) })}>
        {t('ui.minigame.bullying.submit')}
      </button>
    </>
  );
}
